import { ConvexReactClient } from "convex/react";

let cached: ConvexReactClient | null = null;

export function getConvexClient(): ConvexReactClient {
  if (cached) return cached;
  const url = import.meta.env.VITE_CONVEX_URL;
  if (!url) {
    throw new Error(
      "VITE_CONVEX_URL is not set. Run `bunx convex dev` and copy the URL into .env.",
    );
  }
  cached = new ConvexReactClient(url);
  return cached;
}
